module.exports = __webpack_public_path__ + "img/45659.09c2555f.jpg";